export const IDEA_NAME = 'ideaName';
